import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GET_COURSE_REVIEWS } from '../queries/courseReviews';

export const useCourseReviews = (contentId) => {
  const { data, loading, error } = useQuery(GET_COURSE_REVIEWS, {
    variables: { contentId },
    skip: !contentId,
  });

  const reviews = useMemo(() => data?.ratingReview || [], [data]);

  const distribution = useMemo(() => {
    const counts = {
      1: 0, 2: 0, 3: 0, 4: 0, 5: 0,
    };
    reviews.forEach((r) => {
      if (r.rating >= 1 && r.rating <= 5) {
        counts[r.rating] += 1;
      }
    });
    const total = reviews.length;
    const avg = total > 0
      ? reviews.reduce((sum, r) => sum + (r.rating || 0), 0) / total
      : 0;
    return {
      counts,
      total,
      avg: Number(avg.toFixed(1)),
    };
  }, [reviews]);

  return {
    reviews,
    distribution,
    loading,
    error,
  };
};
